<div class="justup-dialog">
  <vl-header-dialog (close)="dialogRef.close()" [rightElement]="excelBtn">
    {{ 'dashboard_ui.w_nc_closure_metrics' | trans }}
  </vl-header-dialog>

  <ng-template #excelBtn>
    <vl-excel-export-button size="medium"
                            [loading]="exporting()"
                            [disabled]="exporting()"
                            [tooltip]="'dashboard_ui.export_excel' | trans"
                            (action)="exportExcel()"/>
  </ng-template>

  <div class="justup-dialog-content flex-col gap-16">
    <!-- Stats cards -->
    <div class="flex-row gap-8 wrap">
      <vl-radio-card mode="display" color="secondary" icon="warning"
                     [title]="'dashboard_ui.nc_kpi_total' | trans"
                     style="flex: 1; min-width: 150px">
        <span content class="headline">{{ data.data?.total ?? 0 }}</span>
      </vl-radio-card>

      <vl-radio-card mode="display" color="valid" icon="check_circle"
                     [title]="'dashboard_ui.nc_kpi_taux_cloture' | trans"
                     style="flex: 1; min-width: 150px">
        <div content class="flex-col gap-2">
          <span class="headline">{{ fmtPct(data.data?.tauxCloture ?? null) }}</span>
          <span class="tiny" style="opacity: 0.7">{{ data.data?.cloturees ?? 0 }} clôturées</span>
        </div>
      </vl-radio-card>

      <vl-radio-card mode="display" color="warn" icon="schedule"
                     [title]="'dashboard_ui.nc_kpi_delai_moyen' | trans"
                     style="flex: 1; min-width: 150px">
        <div content class="flex-col gap-2">
          <span class="headline">{{ fmtDelai(data.data?.delaiMoyenJours ?? null) }}</span>
          <span class="tiny" style="opacity: 0.7">sur {{ data.data?.delaiSamples ?? 0 }} NC</span>
        </div>
      </vl-radio-card>

      <vl-radio-card mode="display" color="secondary" icon="speed"
                     [title]="'dashboard_ui.nc_kpi_sla_j30' | trans"
                     [matTooltip]="'dashboard_ui.nc_kpi_sla_j30_hint' | trans"
                     style="flex: 1; min-width: 150px">
        <span content class="headline">{{ fmtPct(data.data?.slaJ30 ?? null) }}</span>
      </vl-radio-card>
    </div>

    <!-- Délai par décision -->
    @if (decisions().length) {
      <div class="section">
        <span class="subheading-2">{{ 'dashboard_ui.nc_titre_par_decision' | trans }}</span>
        <div class="flex-col gap-4 mt-8">
          @for (d of decisions(); track d.decision) {
            <div class="flex-row align-center gap-8">
              <span class="caption shrink-0" style="min-width: 180px">{{ d.i18nKey | trans }}</span>
              <div class="grow bar-track">
                <div class="bar-fill bar-secondary" [style.width]="decisionBarWidth(d.count)"></div>
              </div>
              <span class="tiny on-disabled shrink-0" style="min-width: 60px; text-align: right">{{ d.count }}</span>
              <span class="tiny on-disabled shrink-0" style="min-width: 80px; text-align: right">{{ fmtDelai(d.delaiMoyenJours) }}</span>
            </div>
          }
        </div>
      </div>
    }

    <!-- Timeline -->
    @if (timeline().length) {
      <div class="section">
        <span class="subheading-2">{{ 'dashboard_ui.nc_titre_evolution' | trans }}</span>
        <div class="flex-col gap-4 mt-8">
          @for (m of timeline(); track m.month) {
            <div class="flex-row align-center gap-8">
              <span class="caption shrink-0" style="min-width: 80px">{{ m.month }}</span>
              <div class="grow bar-track stack">
                <div class="bar-segment bar-cloturees" [style.width]="monthClotureesWidth(m.cloturees)" [matTooltip]="m.cloturees + ' clôturées'"></div>
                <div class="bar-segment bar-ouvertes" [style.width]="monthOuvertesWidth(m.ouvertes)" [matTooltip]="m.ouvertes + ' ouvertes'"></div>
              </div>
              <span class="tiny on-disabled shrink-0" style="min-width: 90px; text-align: right">{{ m.cloturees }}/{{ m.cloturees + m.ouvertes }}</span>
              <span class="tiny on-disabled shrink-0" style="min-width: 70px; text-align: right">{{ fmtDelai(m.delaiMoyenJours) }}</span>
            </div>
          }
        </div>

        <!-- Légende -->
        <div class="flex-row gap-12 mt-8">
          <div class="flex-row align-center gap-4">
            <span class="legend-dot legend-cloturees"></span>
            <span class="tiny on-background-alt">Clôturées</span>
          </div>
          <div class="flex-row align-center gap-4">
            <span class="legend-dot legend-ouvertes"></span>
            <span class="tiny on-background-alt">Ouvertes</span>
          </div>
        </div>
      </div>
    }
  </div>
</div>

<style>
.justup-dialog .section {
  background: var(--color-canvas);
  border: 1px solid var(--color-on-disabled);
  border-radius: 12px;
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
}

.justup-dialog .bar-track {
  height: 8px;
  /* Fond très clair pour contraste — même règle que nc-stats-dialog. */
  background: rgba(0, 0, 0, 0.06);
  border-radius: 4px;
  overflow: hidden;
  min-width: 60px;
  position: relative;
}

.justup-dialog .bar-track.stack {
  display: flex;
  flex-direction: row;
}

.justup-dialog .bar-fill {
  height: 100%;
  border-radius: 4px;
  background: #36A2EB;
}

.justup-dialog .bar-fill.bar-secondary {
  background: #36A2EB;
}

.justup-dialog .bar-segment {
  height: 100%;
}

.justup-dialog .bar-cloturees {
  background: #36A2EB;
}

.justup-dialog .bar-ouvertes {
  background: #FF6384;
}

.justup-dialog .legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
}

.justup-dialog .legend-dot.legend-cloturees {
  background: #36A2EB;
}

.justup-dialog .legend-dot.legend-ouvertes {
  background: #FF6384;
}
</style>
